import React from "react";
import { StudentsUIProvider } from "./StudentsUIContext";
import { StudentsCard } from "./StudentsCard";

export function StudentsPage({
  receipentType,
  noticeId
}) {
  return (
    <StudentsUIProvider noticeId={noticeId}>
      <StudentsCard
        receipentType={receipentType}
      />
    </StudentsUIProvider>
 );
}